import React, { useState } from 'react'
import { Card, Row, Col } from "react-bootstrap"
import RelatedConceptCard from './RelatedConceptCard';
import RelatedConceptInfo from '../RelatedConceptInfo';
import SidePanel from './SidePanel'
import {updateRelatedConcept, addRelatedConcept, deleteRelatedConcept, getRelatedConceptByBookId} from "../../../../services/sBook/book.service";
import ToolBar from '../../../../components/Common/Toolbar';
import { useGetRelatedConceptReference } from '../../../../hooks/services/sBook/useOfRelatedConcept'
import '../../../../styles/css/RelatedConcept.css'
import { useTranslation } from "react-i18next";
import DisabledCard from '../../../Templates/CCard/DisabledCard';
import StatusHeaderItem from '../StatusHeaderItem';
import Message from '../../../Common/Message';
import { __BookRelatedConceptTypes } from '../../../../common/Dictionaries';
import { useDispatch } from 'react-redux';
import { action_setContractParties } from '../../../../reducers/actions/Book/actions';
import { getPartysByBookId } from '../../../../services/sBook/party.service';
import { Toggle } from '@fluentui/react';
import CLabel from '../../../Common/CLabel';
import { isNullUndefined } from '../../../../common/Helpers';


function RelatedConceptCreationBox(props) {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    //Parametros de entrada.
    const inputParam_BookObject = props.bookObject;
    const inputParam_SetterBook = props.setterAuxBookObject;
    const inputParam_SetterBookRelatedConcept = props.setterBookRelatedConcept;
    const inputParam_EditMode = props.editMode !== null && props.editMode !== undefined ? props.editMode : true;
    const inputParam_StatusFly = props.statusFly !== null && props.statusFly !== undefined ? props.statusFly : null;
    const inputParam_SetRelatedConceptHasPartys = props.setRelatedConceptHasPartys !== null && props.setRelatedConceptHasPartys !== undefined ? props.setRelatedConceptHasPartys : null;
    const inputParam_UserHasConfigRoleAction = props.userHasConfigRoleAction !== null && props.userHasConfigRoleAction !== undefined ? props.userHasConfigRoleAction : false;
    const inputParam_IsCreatrionMode = props.isCreatrionMode !== null && props.isCreatrionMode !== undefined ? props.isCreatrionMode : false;
    const inputParam_SetFireGetSectionStructure = props.setFireGetSectionStructure !== null && props.setFireGetSectionStructure !== undefined ? props.setFireGetSectionStructure : null;
    


    //Parametros de componente.
    const [successful, setSuccessful] = useState(null);
    const [message, setMessage] = useState(null);
    const [messageType, setMessageType] = useState(null);
    const [showMessage, setShowMessage] = useState(null);
    
    const [isRelatedConceptPanelOpen, setIsRelatedConceptPanelOpen] = useState(false);
    const [clearRlatedConcept, setClearRlatedConcept] = useState(false);

    const [relatedConceptIsModified, setRelatedConceptIsModified] = useState(false);
    const [relatedMainBookName, setRelatedMainBookName] = useState(null);


    const [relatedConceptTypeList, setRelatedConceptTypeList] = useState(__BookRelatedConceptTypes);

    //ESTE OBJETO TENDRÁ EL "RELATED CONCEPT HAS PARTES"    -> Si es contrato API buscará y dirá true o false.
    //                                                      -> Si no es contrato API dirá false.
    //                                                      -> Si no está asociado un concepto relacionado dirá false.
    // Propiedad del objeto relacionado será "hasParites"
    const [bookRelatedConceptItem, setRelatedConceptItem] = useState(null);

    useGetRelatedConceptReference(inputParam_BookObject, bookRelatedConceptItem, setRelatedConceptItem, clearRlatedConcept, inputParam_SetRelatedConceptHasPartys, setRelatedMainBookName)

    const displayToolBar = (inputParam_BookObject.id !== null) && (relatedConceptTypeList !== null) ? true : false;

    const onRelatedConceptTypeChecked = (idRelatedConceptTypeSelected, set) => {
        for (let index = 0; index < relatedConceptTypeList.length; index++) {
            const element = relatedConceptTypeList[index];
            
            if (element.id === idRelatedConceptTypeSelected) {
                element.selected = true;
            } else {
                element.selected = false;
            }
        }

        set(prevState => ({
            ...prevState,
            relatedConceptTypeId: idRelatedConceptTypeSelected
        }));
        setRelatedConceptTypeList(relatedConceptTypeList);


    };

    const onClearRelatedConcept = (e) => {
        if (bookRelatedConceptItem.id !== 0 && bookRelatedConceptItem.id !== null && bookRelatedConceptItem.id !== undefined) {
            deleteRelatedConcept(bookRelatedConceptItem.id).then((response) => {
                setRelatedConceptItem(null)
                setClearRlatedConcept(true); 
                dispatch(action_setContractParties([], true))
            }).catch(() => {
    
            });
        } else {
            setRelatedConceptItem(null)
            setClearRlatedConcept(true);   
        }
    };

    const selectedRelatedConcept = (value) => { 
        value.id = bookRelatedConceptItem !== null && bookRelatedConceptItem.id  !== undefined ? bookRelatedConceptItem.id : 0;
        setRelatedConceptIsModified(true)
        setRelatedConceptItem(value)
    };


    const onSaveRelatedConcept = (e) => {
        let formIsValid = bookRelatedConceptItem !== null;

        if (formIsValid === true) {

            const objRelatedConcept =
            {
                id: bookRelatedConceptItem !== null && bookRelatedConceptItem.id  !== undefined ? bookRelatedConceptItem.id : 0,
                relatedConceptTypeId: bookRelatedConceptItem.relatedConceptTypeId,
                bookId: inputParam_BookObject.id,
                relatedConceptNemo: "",
                relatedConceptCode: bookRelatedConceptItem.relatedConceptCode,
                name: bookRelatedConceptItem.name,
                contractId: bookRelatedConceptItem.contractId,
                projectId: bookRelatedConceptItem.projectId
            }

            if (objRelatedConcept.projectId !== undefined && objRelatedConcept.contractId !== undefined) {
                if (objRelatedConcept.id === 0) {
                    //Guardar elemento libro.
                    addRelatedConcept(inputParam_BookObject.id, objRelatedConcept).then((response) => {    
                        //LLAMAR A getRelatedConceptByBookId = (bookId) de servicio para obtener el concepto relacionado y
                        //establecer el "RELATED CONCEPT HAS PARTES".
                        getRelatedConceptByBookId(inputParam_BookObject.id).then((responseRelatedConcept) => {
                            getPartysByBookId(inputParam_BookObject.id).then((responseParties) => {
                                if (responseParties.data.succeeded) {
                                    dispatch(action_setContractParties(responseParties.data.data, true))
                                }
                                else {
                                    dispatch(action_setContractParties([], true))
                                }
                            }).catch(() => {
                                dispatch(action_setContractParties([], true))
                            });

                            setSuccessful(true);
                            setMessageType("success");
                            setMessage(t('data-lang-msg-operationperformed'))
                            setShowMessage(true)
                            setRelatedConceptItem(prevState => ({
                                ...prevState,
                                id: response.data.data.related_concept_id
                            }));
                            inputParam_SetterBook && inputParam_SetterBook(prevState => ({
                                ...prevState,
                                mainBook: response.data.data.is_principal
                            }));
                            setRelatedMainBookName(response.data.data.book_name_principal)
                            inputParam_SetterBookRelatedConcept && inputParam_SetterBookRelatedConcept(response.data.data.related_concept_id);
                            setRelatedConceptIsModified(false);

                            inputParam_SetFireGetSectionStructure && inputParam_SetFireGetSectionStructure(true)

                            inputParam_SetRelatedConceptHasPartys && inputParam_SetRelatedConceptHasPartys(!isNullUndefined(responseRelatedConcept.data.data) && responseRelatedConcept.data.data.length > 0 ? responseRelatedConcept.data.data[0].hasPartys : false);
                        }).catch(() => {
                            setSuccessful(false);
                            setMessageType("error");
                            setMessage(t('data-lang-msg-operationerror'))
                            setShowMessage(true)
                        });
                    }).catch(() => {
                        setSuccessful(false);
                        setMessageType("error");
                        setMessage(t('data-lang-msg-operationerror'))
                        setShowMessage(true)
                    });
                } else {
                    //Guardar elemento libro.
                    updateRelatedConcept(objRelatedConcept.id, objRelatedConcept).then((response) => {   
                        getRelatedConceptByBookId(inputParam_BookObject.id).then((responseRelatedConcept) => {
                            getPartysByBookId(inputParam_BookObject.id).then((responseParties) => {
                                if (responseParties.data.succeeded) {
                                    dispatch(action_setContractParties(responseParties.data.data, true))
                                }
                                else {
                                    dispatch(action_setContractParties([], true))
                                }
                            }).catch(() => {
                                dispatch(action_setContractParties([], true))
                            });

                            setSuccessful(true);
                            setMessageType("success");
                            setMessage(t('data-lang-msg-operationperformed'))
                            setShowMessage(true)
                            setRelatedConceptItem(prevState => ({
                                ...prevState,
                                id: response.data.data.related_concept_id
                            }));
                            inputParam_SetterBook && inputParam_SetterBook(prevState => ({
                                ...prevState,
                                mainBook: response.data.data.is_principal
                            }));
                            setRelatedMainBookName(response.data.data.book_name_principal)
                            inputParam_SetterBookRelatedConcept && inputParam_SetterBookRelatedConcept(bookRelatedConceptItem.id);
                            setRelatedConceptIsModified(false)

                            inputParam_SetFireGetSectionStructure && inputParam_SetFireGetSectionStructure(true)

                            inputParam_SetRelatedConceptHasPartys && inputParam_SetRelatedConceptHasPartys(!isNullUndefined(responseRelatedConcept.data.data) && responseRelatedConcept.data.data.length > 0 ? responseRelatedConcept.data.data[0].hasPartys : false);
                        }).catch(() => {
                            setSuccessful(false);
                            setMessageType("error");
                            setMessage(t('data-lang-msg-operationerror'))
                            setShowMessage(true)
                        });
                    }).catch((e) => {
                        setSuccessful(false);
                        setMessageType("error");
                        setMessage(t('data-lang-msg-operationerror'))
                        setShowMessage(true)
                    });
                }
            } else {
                setSuccessful(true);
                setMessageType("warning");
                setMessage(t('data-lang-msg-relatedconcepttypenotselected'))
                setShowMessage(true)
            }
        } else {
            setSuccessful(true);
            setMessageType("warning");
            setMessage(t('data-lang-msg-relatedconcepttypenotselected'))
            setShowMessage(true)
        }
    };

    const onSelectSpecificRelatedConcept = (e) => {
        if (bookRelatedConceptItem !== null && bookRelatedConceptItem.relatedConceptTypeId !== null) {
            setIsRelatedConceptPanelOpen(true);
        } else {
            setSuccessful(true);
            setMessageType("warning");
            setMessage(t('data-lang-msg-relatedconcepttypenotselected'))
            setShowMessage(true)
        }
    };

    //Toolbars.  
    const toolBarItems_RelatedConcept  = [
        {
            key: 'save',
            style: { display: relatedConceptIsModified || (bookRelatedConceptItem !== null && bookRelatedConceptItem.id === undefined) ? "block" : "none" },
            text: t('data-lang-btn-save'),
            iconProps: { iconName: 'Save' },
            onClick: onSaveRelatedConcept,
        },
        {
            key: 'select',
            text: t('data-lang-btn-select'),
            iconProps: { iconName: 'CircleAddition' },
            onClick: onSelectSpecificRelatedConcept,
        },
        {
            key: 'clear',
            text: t('data-lang-btn-clear'),
            iconProps: { iconName: 'SyncStatus' },
            onClick: onClearRelatedConcept,
        },
    ];

    const displayBookUserBox = inputParam_BookObject.id !== null;

    //Primer .map corresponde a card del tipo de concepto relacionado seleccionado, cuando la card de info se despliega.
    //Segundo .map corresponde a card de la info del elemento relacionado seleccionado en el panel lateral, esto cuanto el tipo de elemento tambien fue seleccionado.
    //Tercer .map corresponde a las card de los tipos de concepto relacionado cuando no hay uno especifico seleccionado en el panel lateral.
    //Se tuvo que hacer de esta forma compleja dado que de otras formas se generaba el problema con la "key" de los elementos iterados.
    return (
        <Card className='book-related-concept-form h-100'>
            <DisabledCard display={ !displayBookUserBox } />
            <Card.Header className="card-header-compact">
                <Card.Title className="d-flex justify-content-between">
                    <Row>
                        {
                            inputParam_EditMode === true && (inputParam_IsCreatrionMode ? true : inputParam_UserHasConfigRoleAction) &&
                            <Col className='col-auto ms-auto'>
                                <StatusHeaderItem index={ 2 } statusId={ inputParam_StatusFly } />
                            </Col>
                        }
                        <Col className={ inputParam_EditMode && (inputParam_IsCreatrionMode ? true : inputParam_UserHasConfigRoleAction) ? "ps-4 ms-3" : "" } >
                            <b>{t('data-lang-boxname-relatedconcept')}</b>
                        </Col>
                    </Row>
                </Card.Title>
            </Card.Header>
            <Card.Footer className='w-100' style={{padding: "0px", minHeight:"46px", borderBottom: "1px solid rgba(0, 0, 0, 0.125)"}}>
                <div className='book-toolbar d-flex float-end'>
                    { inputParam_EditMode && (inputParam_IsCreatrionMode ? true : inputParam_UserHasConfigRoleAction) && <ToolBar items={ toolBarItems_RelatedConcept } display={displayToolBar} />}
                </div>
            </Card.Footer>
            <Card.Body className='pt-2 w-100 h-100'>
                <Row>
                    <Col className='col-auto me-auto'>
                    {
                        !isNullUndefined(inputParam_BookObject.mainBook) &&
                        <Toggle
                            checked={ inputParam_BookObject.mainBook }
                            role="checkbox"
                            onText={ t('data-lang-lbl-hasprincipalbook') }
                            offText={ t('data-lang-lbl-doesnthaveprincipalbook') }
                            styles={ {root:{display: "flex"}, label: {marginRight : "5px"}} }
                            disabled={true}
                        />
                    }
                    </Col>
                    {
                    relatedMainBookName &&
                    <Col><CLabel labelText={t('data-lang-lbl-mainbookname')} labelValue={relatedMainBookName} /></Col>
                    }
                </Row>
                {
                    displayBookUserBox &&
                    <Row className='layerBlockedContent'>
                        <Col>
                            <Row>
                                {
                                    //Si no hay un concepto relacionado seleccionado o si el concepto relacionado del objeto book es no seleccionado.
                                    (bookRelatedConceptItem === null || bookRelatedConceptItem === undefined) ?
                                    <>
                                        {
                                            relatedConceptTypeList && relatedConceptTypeList.map((conceptType, index) =>
                                                <Col key={index} sm={12} xl={6}>
                                                    <RelatedConceptCard
                                                        relatedConceptType={conceptType}
                                                        selectedItemTypeId={ bookRelatedConceptItem ? bookRelatedConceptItem.relatedConceptTypeId : bookRelatedConceptItem }
                                                        setSelectedRelatedConceptType={onRelatedConceptTypeChecked}
                                                        set={setRelatedConceptItem}
                                                        editMode={inputParam_EditMode}
                                                        userHasConfigRoleAction={(inputParam_IsCreatrionMode ? true : inputParam_UserHasConfigRoleAction)}
                                                    />
                                                </Col>
                                            )
                                        }
                                    </> : <></>                             
                                }
                            </Row>
                            <Row>
                                {
                                    //Si hay un concepto relacionado seleccionado en el objeto book
                                    (bookRelatedConceptItem !== null && bookRelatedConceptItem !== undefined) &&
                                    relatedConceptTypeList && bookRelatedConceptItem &&
                                    <>
                                        <Col sm={12} xl={6}>
                                            <RelatedConceptCard
                                                relatedConceptType={relatedConceptTypeList.find(x => x.id === bookRelatedConceptItem.relatedConceptTypeId)}
                                                selectedItemTypeId={bookRelatedConceptItem.relatedConceptTypeId}
                                                setSelectedRelatedConceptType={onRelatedConceptTypeChecked}
                                            />
                                        </Col>
                                        <Col sm={12} xl={6}>
                                            <RelatedConceptInfo relatedConceptItem={ bookRelatedConceptItem } />
                                        </Col>
                                    </>
                                }
                            </Row>
                        </Col>
                    </Row>
                }
                <SidePanel setterRelatedConceptItem={ selectedRelatedConcept } relatedConcept={ bookRelatedConceptItem } isPanelOpen={ isRelatedConceptPanelOpen } setIsPanelOpen={ setIsRelatedConceptPanelOpen } />
            </Card.Body>
            <Card.Footer>
                <Message message={ message } display={ successful === null? false : showMessage } messageType={ messageType } setterShowMessage={ setShowMessage } />
            </Card.Footer>
        </Card>
    );
}

export default RelatedConceptCreationBox;